/**
 * Frame Options - Dynamic Print Type Selector
 *
 * Reads print_types metaobject data and builds UI dynamically.
 * Each print type can have: laminated, canvas_wrap_print, foam_board,
 * wood_moulding (with color variants), and frame swatches.
 */
(function () {
  var container = document.querySelector('[data-frame-options]');
  if (!container) return;

  var configEl = document.querySelector('[data-frame-options-config]');
  if (!configEl) return;

  var config = JSON.parse(configEl.textContent);
  config.printTypes = (config.printTypes || []).filter(Boolean);

  if (config.printTypes.length === 0) return;

  // --- Elements ---
  var cards = container.querySelectorAll('[data-option-type]');
  var printSizeSelect = container.querySelector('[data-field="print-size"]');
  var dynamicPanels = container.querySelector('[data-dynamic-panels]');
  var basePriceEl = container.querySelector('[data-base-price]');
  var addonRowsEl = container.querySelector('[data-addon-rows]');
  var totalPriceEl = container.querySelector('[data-total-price]');
  var leadTimeTextEl = container.querySelector('[data-lead-time-text]');
  var currentType = config.printTypes[0].handle;

  // --- Helpers ---

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function parseDimensions(sizeStr) {
    if (!sizeStr) return { width: 0, height: 0 };
    var cleaned = sizeStr.replace(/cm|in|"|'/gi, '').trim();
    var parts = cleaned.split(/\s*[xX×]\s*/);
    return { width: parseFloat(parts[0]) || 0, height: parseFloat(parts[1]) || 0 };
  }

  function getSquareInches(dim) { return dim.width * dim.height; }
  function getPerimeter(dim) { return (dim.width + dim.height) * 2; }
  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function getCurrentDimensions() {
    return parseDimensions(printSizeSelect ? printSizeSelect.value : '');
  }

  function getPrintType(handle) {
    return config.printTypes.find(function (pt) { return pt.handle === handle; }) || null;
  }

  function getMainVariantId() {
    // frame-options container is outside the form, so search within the product section
    var sectionEl = container.closest('[data-section-id]') || container.closest('.product__section') || document;
    var input = sectionEl.querySelector('.formVariantId');
    return input ? input.value : null;
  }

  function getSelectedFrameData() {
    var pt = getPrintType(currentType);
    if (!pt) return null;
    var frames = (pt.frame || []).filter(Boolean);
    if (frames.length === 0) return null;

    var activePanel = dynamicPanels.querySelector('[data-panel-for="' + currentType + '"]');
    if (!activePanel) return frames[0];

    var allSwatches = activePanel.querySelectorAll('[data-field="wood-moulding-swatches"] .frame-options__swatch');
    for (var i = 0; i < allSwatches.length; i++) {
      if (allSwatches[i].classList.contains('is-active')) {
        return frames[i] || frames[0];
      }
    }
    return frames[0];
  }

  function isMatEnabled() {
    var activePanel = dynamicPanels.querySelector('[data-panel-for="' + currentType + '"]');
    if (!activePanel) return false;
    var matCb = activePanel.querySelector('[data-field="mat"]');
    return matCb ? matCb.checked : false;
  }

  function isCanvasWrapEnabled() {
    var activePanel = dynamicPanels.querySelector('[data-panel-for="' + currentType + '"]');
    if (!activePanel) return false;
    var cwCb = activePanel.querySelector('[data-field="canvas-wrap"]');
    return cwCb ? cwCb.checked : false;
  }

  function emitPreviewUpdate() {
    var detail = {
      type: currentType,
      printSize: getCurrentDimensions(),
      frameData: getSelectedFrameData(),
      matEnabled: isMatEnabled(),
      canvasWrap: isCanvasWrapEnabled()
    };
    window._lastFrameDetail = detail;
    document.dispatchEvent(new CustomEvent('frame-options:change', { detail: detail }));
  }

  // --- Build dynamic panels per print type ---

  function buildPanels() {
    var html = '';

    config.printTypes.forEach(function (pt, idx) {
      var visible = idx === 0 ? '' : ' style="display:none;"';
      html += '<div class="frame-options__type-panel" data-panel-for="' + pt.handle + '"' + visible + '>';

      // Laminated checkbox
      if (pt.laminated) {
        var laminateVariant = pt.laminated.variants && pt.laminated.variants[0];
        var laminatePrice = laminateVariant ? laminateVariant.price : 0;
        html += '<div class="frame-options__field">';
        html += '<label class="frame-options__label">';
        html += '<input type="checkbox" data-field="laminated" data-variant-id="' + (laminateVariant ? laminateVariant.id : '') + '" data-unit-price="' + laminatePrice + '" data-measure="area" class="frame-options__checkbox">';
        html += ' ADD LAMINATION';
        html += ' <span class="frame-options__price-hint" data-price-hint="laminated"></span>';
        html += '</label>';
        html += '</div>';
      }

      // Wood Moulding (frame color select)
      if (pt.wood_moulding && pt.wood_moulding.variants) {
        html += '<div class="frame-options__field">';
        html += '<label class="frame-options__label">FRAME COLOR</label>';

        // If we have frame swatches with thumbnails, show swatches
        var frames = (pt.frame || []).filter(Boolean);
        if (frames.length > 0 && frames[0].thumbnail) {
          html += '<div class="frame-options__swatches" data-field="wood-moulding-swatches">';
          pt.wood_moulding.variants.forEach(function (v, vi) {
            var frameData = frames[vi] || {};
            var thumb = frameData.thumbnail || '';
            html += '<button type="button" class="frame-options__swatch' + (vi === 0 ? ' is-active' : '') + '" data-variant-id="' + v.id + '" data-unit-price="' + v.price + '" data-label="' + (v.option1 || v.title) + '">';
            if (thumb) {
              html += '<img src="' + thumb + '" alt="' + (frameData.label || v.option1) + '">';
            }
            html += '</button>';
          });
          html += '</div>';
        } else {
          // Fallback to select
          html += '<div class="frame-options__select-wrap">';
          html += '<select class="frame-options__select" data-field="wood-moulding-select">';
          html += '<option value="">Select a frame...</option>';
          pt.wood_moulding.variants.forEach(function (v) {
            html += '<option value="' + v.id + '" data-unit-price="' + v.price + '">' + (v.option1 || v.title) + '</option>';
          });
          html += '</select>';
          html += '</div>';
        }
        html += '</div>';
      }

      // Foam Board (auto-included with framed, no UI needed but store data)
      if (pt.foam_board) {
        var fbVariant = pt.foam_board.variants && pt.foam_board.variants[0];
        var fbPrice = fbVariant ? fbVariant.price : (pt.foam_board.price || 0);
        var fbVid = fbVariant ? fbVariant.id : pt.foam_board.id;
        html += '<input type="hidden" data-field="foam-board" data-variant-id="' + fbVid + '" data-unit-price="' + fbPrice + '" data-measure="area" data-label="' + (pt.foam_board.title || 'Foam Board') + '">';
      }

      // Mat checkbox
      if (pt.mat) {
        var matVariant = pt.mat.variants && pt.mat.variants[0];
        var matPrice = matVariant ? matVariant.price : 0;
        html += '<div class="frame-options__field">';
        html += '<label class="frame-options__label">';
        html += '<input type="checkbox" data-field="mat" data-variant-id="' + (matVariant ? matVariant.id : '') + '" data-unit-price="' + matPrice + '" data-measure="area" class="frame-options__checkbox">';
        html += ' ADD MAT';
        html += ' <span class="frame-options__price-hint" data-price-hint="mat"></span>';
        html += '</label>';
        html += '</div>';
      }

      // Canvas Wrap Print checkbox
      if (pt.canvas_wrap_print) {
        var cwVariant = pt.canvas_wrap_print.variants && pt.canvas_wrap_print.variants[0];
        var cwPrice = cwVariant ? cwVariant.price : 0;
        html += '<div class="frame-options__field">';
        html += '<label class="frame-options__label">';
        html += '<input type="checkbox" data-field="canvas-wrap" data-variant-id="' + (cwVariant ? cwVariant.id : '') + '" data-unit-price="' + cwPrice + '" data-measure="perimeter" class="frame-options__checkbox">';
        html += ' ADD CANVAS WRAP';
        html += ' <span class="frame-options__price-hint" data-price-hint="canvas-wrap"></span>';
        html += '</label>';
        html += '</div>';
      }

      html += '</div>';
    });

    dynamicPanels.innerHTML = html;
  }

  // --- Panel visibility ---

  function showPanelFor(handle) {
    var panels = dynamicPanels.querySelectorAll('[data-panel-for]');
    panels.forEach(function (p) {
      p.style.display = p.dataset.panelFor === handle ? '' : 'none';
    });
    if (leadTimeTextEl) {
      leadTimeTextEl.textContent = handle === 'art-print'
        ? 'Lead time before shipping: 1-2 business days'
        : 'Lead time before shipping: 3-5 business days';
    }
  }

  // --- Price calculation ---
  //
  // Measurement rules:
  //   AREA (sq in)      = width × height          → Laminated, Foam Board, Mat, Canvas Print
  //   PERIMETER (in)    = (width + height) × 2    → Wood Moulding (frame), Canvas Wrap
  //
  // Each accessory variant price is the cost PER UNIT (per sq-in or per inch) in cents.
  // Cart quantity = measurement units (sq inches or perimeter inches).
  // Total addon cost = quantity × unit price (cents).
  // Final prices are rounded UP to the nearest cent.

  function getAddonCost(qty, unitPriceCents) {
    return Math.ceil(qty * unitPriceCents);
  }

  function calculateAndUpdate() {
    var dim = getCurrentDimensions();
    var sqIn = getSquareInches(dim);     // e.g. 24×36 = 864
    var perim = getPerimeter(dim);       // e.g. (24+36)×2 = 120
    var basePrice = config.basePrice;
    var addons = []; // { label, cents }

    var pt = getPrintType(currentType);
    if (!pt) return;

    var activePanel = dynamicPanels.querySelector('[data-panel-for="' + currentType + '"]');
    if (!activePanel) return;

    // --- Laminated (area-based, optional checkbox) ---
    var laminatedCb = activePanel.querySelector('[data-field="laminated"]');
    if (laminatedCb) {
      var lUnitPrice = Number(laminatedCb.dataset.unitPrice) || 0;
      var lCost = getAddonCost(sqIn, lUnitPrice);
      var lHint = activePanel.querySelector('[data-price-hint="laminated"]');
      if (lHint) {
        lHint.textContent = sqIn > 0 && lUnitPrice > 0 ? '(+' + formatMoney(lCost) + ')' : '';
      }
      if (laminatedCb.checked && sqIn > 0) {
        addons.push({ label: (pt.laminated && pt.laminated.title) || 'Lamination', cents: lCost });
      }
    }

    // --- Wood Moulding / Frame (perimeter-based, always included when present) ---
    var swatches = activePanel.querySelectorAll('[data-field="wood-moulding-swatches"] .frame-options__swatch');
    var wmSelect = activePanel.querySelector('[data-field="wood-moulding-select"]');
    var wmUnitPrice = 0;

    if (swatches.length > 0) {
      var activeSwatch = activePanel.querySelector('.frame-options__swatch.is-active');
      if (activeSwatch) {
        wmUnitPrice = Number(activeSwatch.dataset.unitPrice) || 0;
      }
    } else if (wmSelect && wmSelect.value) {
      var selOpt = wmSelect.options[wmSelect.selectedIndex];
      wmUnitPrice = Number(selOpt.dataset.unitPrice) || 0;
    }

    if (wmUnitPrice > 0 && perim > 0) {
      addons.push({ label: (pt.wood_moulding && pt.wood_moulding.title) || 'Frame', cents: getAddonCost(perim, wmUnitPrice) });
    }

    // --- Foam Board (area-based, auto-included when present — every frame needs one) ---
    var foamInput = activePanel.querySelector('[data-field="foam-board"]');
    if (foamInput) {
      var fbUnitPrice = Number(foamInput.dataset.unitPrice) || 0;
      if (fbUnitPrice > 0 && sqIn > 0) {
        addons.push({ label: foamInput.dataset.label || 'Foam Board', cents: getAddonCost(sqIn, fbUnitPrice) });
      }
    }

    // --- Mat (area-based, optional checkbox) ---
    var matCb = activePanel.querySelector('[data-field="mat"]');
    if (matCb) {
      var matUnitPrice = Number(matCb.dataset.unitPrice) || 0;
      var matCost = getAddonCost(sqIn, matUnitPrice);
      var matHint = activePanel.querySelector('[data-price-hint="mat"]');
      if (matHint) {
        matHint.textContent = sqIn > 0 && matUnitPrice > 0 ? '(+' + formatMoney(matCost) + ')' : '';
      }
      if (matCb.checked && sqIn > 0) {
        addons.push({ label: (pt.mat && pt.mat.title) || 'Mat', cents: matCost });
      }
    }

    // --- Canvas Wrap (perimeter-based, optional checkbox) ---
    var cwCb = activePanel.querySelector('[data-field="canvas-wrap"]');
    if (cwCb) {
      var cwUnitPrice = Number(cwCb.dataset.unitPrice) || 0;
      var cwCost = getAddonCost(perim, cwUnitPrice);
      var cwHint = activePanel.querySelector('[data-price-hint="canvas-wrap"]');
      if (cwHint) {
        cwHint.textContent = perim > 0 && cwUnitPrice > 0 ? '(+' + formatMoney(cwCost) + ')' : '';
      }
      if (cwCb.checked && perim > 0) {
        addons.push({ label: (pt.canvas_wrap_print && pt.canvas_wrap_print.title) || 'Canvas Wrap', cents: cwCost });
      }
    }

    var addonCents = addons.reduce(function (sum, a) { return sum + a.cents; }, 0);

    // --- Update UI ---
    if (basePriceEl) basePriceEl.textContent = formatMoney(basePrice);

    if (addonRowsEl) {
      var rowsHtml = '';
      addons.forEach(function (a) {
        rowsHtml += '<div class="frame-options__price-row frame-options__price-row--addon">';
        rowsHtml += '<span>' + a.label + ':</span>';
        rowsHtml += '<span>+' + formatMoney(a.cents) + '</span>';
        rowsHtml += '</div>';
      });
      addonRowsEl.innerHTML = rowsHtml;
    }

    if (totalPriceEl) totalPriceEl.textContent = formatMoney(basePrice + addonCents);

    // Update sticky add to cart price
    var stickyPrice = document.querySelector('.sticky-atc__price');
    if (stickyPrice) stickyPrice.textContent = formatMoney(basePrice + addonCents);
  }

  // --- Build cart items ---

  // --- Build cart items ---
  //
  // Bundle structure:
  //   1. Main product (qty=1) with print type label
  //   2. Accessory items (qty=measurement) each linked by _bundle_id
  //
  // Quantity rules:
  //   AREA accessories    → quantity = width × height (sq inches)
  //   PERIMETER accessories → quantity = (width + height) × 2 (inches)
  //
  // Shopify charges: variant_price × quantity
  //   e.g. Foam Board variant=$0.028, qty=864 → $0.028 × 864 = $24.19

  function buildCartItems() {
    var dim = getCurrentDimensions();
    var sqIn = Math.round(getSquareInches(dim));      // area in sq inches
    var perim = Math.round(getPerimeter(dim));         // perimeter in inches
    var mainVariantId = getMainVariantId();
    var bundleId = generateUUID();
    var items = [];
    var pt = getPrintType(currentType);

    if (!mainVariantId || !pt) return null;

    // Read quantity from PDP quantity input
    var sectionEl = container.closest('[data-section-id]') || container.closest('.product__section') || document;
    var qtyInput = sectionEl.querySelector('.formQty');
    var mainQty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

    var dimLabel = dim.width + '" × ' + dim.height + '"';

    // 1. Main product
    items.push({
      id: parseInt(mainVariantId),
      quantity: mainQty,
      properties: {
        '_bundle_id': bundleId,
        '_bundle_role': 'main',
        'Print Type': pt.label || currentType,
        'Size': dimLabel
      }
    });

    var activePanel = dynamicPanels.querySelector('[data-panel-for="' + currentType + '"]');
    if (!activePanel) return items;

    // Helper: push accessory item (qty = per-unit measurement, multiplied by mainQty)
    function addAccessory(variantId, baseQty, type, measure, extra) {
      if (!variantId || baseQty <= 0) return;
      var qty = baseQty * mainQty;
      var props = {
        '_bundle_id': bundleId,
        '_bundle_role': 'accessory',
        '_accessory_type': type,
        '_base_qty': String(baseQty),
        '_measurement': measure,
        '_size': dimLabel
      };
      if (extra) {
        for (var k in extra) props[k] = extra[k];
      }
      items.push({
        id: parseInt(variantId),
        quantity: qty,
        properties: props
      });
    }

    // 2. Laminated (area-based, optional)
    var laminatedCb = activePanel.querySelector('[data-field="laminated"]');
    if (laminatedCb && laminatedCb.checked) {
      addAccessory(laminatedCb.dataset.variantId, sqIn, 'Lamination', sqIn + ' sq in');
    }

    // 3. Wood Moulding / Frame (perimeter-based, always included when present)
    var swatches = activePanel.querySelectorAll('[data-field="wood-moulding-swatches"] .frame-options__swatch');
    var wmSelect = activePanel.querySelector('[data-field="wood-moulding-select"]');
    var wmVariantId = null;
    var wmLabel = '';

    if (swatches.length > 0) {
      var activeSwatch = activePanel.querySelector('.frame-options__swatch.is-active');
      if (activeSwatch) {
        wmVariantId = activeSwatch.dataset.variantId;
        wmLabel = activeSwatch.dataset.label || '';
      }
    } else if (wmSelect && wmSelect.value) {
      wmVariantId = wmSelect.value;
      wmLabel = wmSelect.options[wmSelect.selectedIndex].textContent.trim();
    }

    if (wmVariantId) {
      addAccessory(wmVariantId, perim, 'Frame', perim + ' in (perimeter)', { '_frame_color': wmLabel });
    }

    // 4. Foam Board (area-based, auto-included — every frame needs one)
    var foamInput = activePanel.querySelector('[data-field="foam-board"]');
    if (foamInput && foamInput.dataset.variantId) {
      addAccessory(foamInput.dataset.variantId, sqIn, 'Foam Board', sqIn + ' sq in');
    }

    // 5. Mat (area-based, optional)
    var matCb = activePanel.querySelector('[data-field="mat"]');
    if (matCb && matCb.checked) {
      addAccessory(matCb.dataset.variantId, sqIn, 'Mat', sqIn + ' sq in');
    }

    // 6. Canvas Wrap (perimeter-based, optional)
    var cwCb = activePanel.querySelector('[data-field="canvas-wrap"]');
    if (cwCb && cwCb.checked) {
      addAccessory(cwCb.dataset.variantId, perim, 'Canvas Wrap', perim + ' in (perimeter)');
    }

    return items;
  }

  // --- Validation ---

  function validateSelections() {
    var pt = getPrintType(currentType);
    if (!pt) return false;

    // If wood_moulding exists, a frame must be selected
    if (pt.wood_moulding) {
      var activePanel = dynamicPanels.querySelector('[data-panel-for="' + currentType + '"]');
      var swatches = activePanel.querySelectorAll('[data-field="wood-moulding-swatches"] .frame-options__swatch');
      var wmSelect = activePanel.querySelector('[data-field="wood-moulding-select"]');

      if (swatches.length === 0 && wmSelect && !wmSelect.value) {
        alert('Please select a frame color.');
        return false;
      }
    }
    return true;
  }

  // --- Add to cart ---

  function addBundleToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          console.error('Cart add error:', err);
          throw new Error(err.description || err.message || 'Add to cart failed');
        });
      }
      return res.json();
    });
  }

  // --- Intercept add to cart ---

  function interceptAddToCart() {
    var sectionEl = container.closest('[data-section-id]') || container.closest('.product__section');
    if (!sectionEl) return;

    var submitBtn = sectionEl.querySelector('.js-ajax-submit');
    if (!submitBtn) return;

    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!validateSelections()) return;

      var items = buildCartItems();
      if (!items || items.length === 0) return;

      var originalText = submitBtn.textContent || submitBtn.value;
      var stickyBtn = document.querySelector('.sticky-atc__btn');
      var stickyOrigText = stickyBtn ? stickyBtn.textContent : '';

      // Disable both buttons
      submitBtn.disabled = true;
      if (submitBtn.tagName === 'INPUT') { submitBtn.value = 'Adding...'; }
      else { submitBtn.textContent = 'Adding...'; }
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Adding...'; }

      addBundleToCart(items)
        .then(function () {
          return Shopify.theme.cart.getCart();
        })
        .then(function (cart) {
          // Restore both buttons
          submitBtn.disabled = false;
          if (submitBtn.tagName === 'INPUT') { submitBtn.value = originalText; }
          else { submitBtn.textContent = originalText; }
          if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = stickyOrigText; }

          // Read cart config from theme
          var cartConfigEl = document.getElementById('cart-config');
          if (!cartConfigEl) return;
          var cartConfig = JSON.parse(cartConfigEl.innerHTML || '{}');

          // Let theme update the cart view (drawer/modal content + loading state)
          Shopify.theme.ajaxCart.updateView(cartConfig, cart);

          // Open drawer/modal using theme's methods
          if (cartConfig.cart_action === 'drawer' && cartConfig.cart_added_event === 'go_to_active_cart') {
            Shopify.theme.ajaxCart.showDrawer(cartConfig);
          } else if (cartConfig.cart_action === 'modal_cart' && cartConfig.cart_added_event === 'go_to_active_cart') {
            Shopify.theme.ajaxCart.showModal(cartConfig);
          } else if (cartConfig.cart_action === 'page_only' && cartConfig.cart_added_event === 'go_to_active_cart') {
            window.location.href = cartConfig.cart_url || '/cart';
          } else if (cartConfig.cart_added_event === 'product_page') {
            var addedMsg = sectionEl.querySelector('.js-added-msg');
            if (addedMsg) {
              theme.Helpers.fadeIn(addedMsg);
              setTimeout(function () { theme.Helpers.fadeOut(addedMsg); }, 3000);
            }
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          if (submitBtn.tagName === 'INPUT') { submitBtn.value = originalText; }
          else { submitBtn.textContent = originalText; }
          if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = stickyOrigText; }
          alert('Could not add to cart. Please try again.');
        });
    }, true);
  }

  // --- Variant sync ---

  function findVariantBySize(sizeValue) {
    if (!config.variants || !sizeValue) return null;
    return config.variants.find(function (v) {
      return v.option1 === sizeValue || v.option2 === sizeValue || v.option3 === sizeValue;
    }) || null;
  }

  function syncVariantWithSize(sizeValue) {
    var mainSizeSelect = document.querySelector(
      'select.js-variant-selector[name*="Size"], select.js-variant-selector[name*="size"]'
    );
    if (mainSizeSelect) {
      var options = mainSizeSelect.querySelectorAll('option');
      for (var i = 0; i < options.length; i++) {
        if (options[i].value === sizeValue || options[i].textContent.trim() === sizeValue) {
          mainSizeSelect.value = options[i].value;
          mainSizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    var swatchInputs = document.querySelectorAll('.product__variants-swatches input[type="radio"]');
    swatchInputs.forEach(function (input) {
      if (input.value === sizeValue) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function updateFromVariant(sizeValue) {
    var variant = findVariantBySize(sizeValue);
    if (variant) {
      config.basePrice = variant.price;
      config.currentVariantId = variant.id;
      var hiddenInput = container.closest('form') ? container.closest('form').querySelector('.formVariantId') : null;
      if (hiddenInput) {
        hiddenInput.value = variant.id;
        hiddenInput.setAttribute('data-inventory-quantity', variant.inventory_quantity || '');
      }
    }
  }

  // --- Event listeners ---

  // Card selection
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      cards.forEach(function (c) { c.classList.remove('is-active'); });
      card.classList.add('is-active');
      currentType = card.dataset.optionType;
      showPanelFor(currentType);
      calculateAndUpdate();
      emitPreviewUpdate();
    });
  });

  // Print Size change
  if (printSizeSelect) {
    // Sibling product search — find same product in different sizes
    var siblingQuery = printSizeSelect.dataset.siblingSearch;
    if (siblingQuery) {
      (function () {
        var sizePattern = /\d+\s*[xX×]\s*\d+/;
        var currentHandle = printSizeSelect.dataset.currentHandle;
        fetch('/search?view=sibling&q=' + encodeURIComponent(siblingQuery) + '&type=product')
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var products = JSON.parse(text.trim());
            var baseNorm = siblingQuery.toLowerCase().replace(/[^a-z0-9]/g, '');
            products.forEach(function (p) {
              if (p.handle === currentHandle) return;
              var titleMatch = p.title.match(sizePattern);
              if (!titleMatch) return;
              var pBase = p.title.replace(sizePattern, '').replace(/[()[\]|_-]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
              if (pBase !== baseNorm) return;
              var size = titleMatch[0];
              // Skip if spacing format doesn't match current size (e.g. "27 x 40" vs "27x40")
              var currentSize = printSizeSelect.options[0] ? printSizeSelect.options[0].value : '';
              var currentHasSpaces = /\d\s+[xX×]\s+\d/.test(currentSize);
              var siblingHasSpaces = /\d\s+[xX×]\s+\d/.test(size);
              if (currentHasSpaces !== siblingHasSpaces) return;
              // Avoid duplicate sizes
              var exists = false;
              for (var i = 0; i < printSizeSelect.options.length; i++) {
                if (printSizeSelect.options[i].value === size) { exists = true; break; }
              }
              if (exists) return;
              var opt = document.createElement('option');
              opt.value = size;
              opt.textContent = size;
              opt.dataset.handle = p.handle;
              printSizeSelect.appendChild(opt);
            });
            if (printSizeSelect.options.length > 1) {
              printSizeSelect.disabled = false;
            }
          })
          .catch(function () { /* silently fail — keep single disabled option */ });
      })();
    }

    printSizeSelect.addEventListener('change', function () {
      // If sibling redirect
      var selectedOption = printSizeSelect.options[printSizeSelect.selectedIndex];
      if (selectedOption && selectedOption.dataset.handle && selectedOption.dataset.handle !== (printSizeSelect.dataset.currentHandle || '')) {
        window.location.href = '/products/' + selectedOption.dataset.handle;
        return;
      }
      var sizeValue = printSizeSelect.value;
      updateFromVariant(sizeValue);
      syncVariantWithSize(sizeValue);
      setTimeout(function () {
        var priceEl = document.querySelector('.product__section .product_price .money');
        if (priceEl) {
          var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
          var parsedPrice = Math.round(parseFloat(priceText) * 100);
          if (parsedPrice > 0) config.basePrice = parsedPrice;
        }
        calculateAndUpdate();
        emitPreviewUpdate();
      }, 500);
      calculateAndUpdate();
      emitPreviewUpdate();
    });
  }

  // Delegate events inside dynamic panels
  dynamicPanels.addEventListener('change', function (e) {
    if (e.target.matches('[data-field="laminated"], [data-field="mat"], [data-field="canvas-wrap"], [data-field="wood-moulding-select"]')) {
      calculateAndUpdate();
      emitPreviewUpdate();
    }
  });

  dynamicPanels.addEventListener('click', function (e) {
    var swatch = e.target.closest('.frame-options__swatch');
    if (swatch) {
      var container = swatch.closest('[data-field="wood-moulding-swatches"]');
      container.querySelectorAll('.frame-options__swatch').forEach(function (s) {
        s.classList.remove('is-active');
      });
      swatch.classList.add('is-active');
      calculateAndUpdate();
      emitPreviewUpdate();
    }
  });

  // Listen for variant changes from theme
  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('formVariantId')) {
      setTimeout(function () {
        var newVariantId = parseInt(e.target.value);
        if (!newVariantId) return;
        var variant = config.variants.find(function (v) { return v.id === newVariantId; });
        if (variant) {
          config.basePrice = variant.price;
          config.currentVariantId = variant.id;
          var sizeOption = variant.option1 || '';
          if (printSizeSelect && printSizeSelect.value !== sizeOption) {
            printSizeSelect.value = sizeOption;
          }
        }
        calculateAndUpdate();
        emitPreviewUpdate();
      }, 100);
    }
  });

  buildPanels();
  showPanelFor(currentType);
  calculateAndUpdate();
  interceptAddToCart();
  // Initial preview render after a short delay for carousel to be ready
  setTimeout(emitPreviewUpdate, 500);
})();
